import { ListConfig } from '@shared/modules/list/interfaces/list-config.interface';
import { Config } from '@shared/configs/config';

export const MyWorkListConfig: ListConfig = {
  url: `${Config.API}/task-list/my-task`,
  listName: 'my-work-list',
  responseKey: ''
};
